module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "work"
  }, [_c('navigation'), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('slider')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1aa8812c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/spa/Work/Work.vue
// module id = 264
// module chunks = 0